export const subscribeButton = {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginBottom: "15px"
}

export const divEmail = {
    backgroundColor:"#fff2cd",
    borderRadius: "20px",
    width: "100%",
    borderStyle: "solid",
    borderColor: "#e2660e",
    borderWidth: "2px",
    marginBottom: "10px"
}


export const alreadySaveAreaDesktop = {
    paddingTop: "10px",
    paddingBottom: "10px",
    borderRadius: "30px",
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: "2px",
    textAlign: "center",
    background: "#e2660e",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
    marginLeft: "10px",
    color: "white"
}